export const sharedPalette = {
  atRed: '#f12330',
  kYellow: '#fcd110',
  cbYellow: '#facb11',
  watermelon: '#ff4d57',
  darkWatermelon: '#e81939',
  lightBeige: '#feeee6',
  lightPink: '#fed9d0',
  lightYellow: '#fddd87',
  lightBlue: '#f3f6fd',
  lightPurple: '#f0e4f1',
  terracotta: '#fd7d60',
  tobacco: '#d4830e',
  amethyst: '#e07fd7',
  emerald: '#6cc984',
  rose: '#ffa4c6',
  email: '#f0ba7d',
  facebook: '#3b5998',
  flipboard: '#f52828',
  instagram: '#724bc5',
  pinterest: '#cb2128',
  saveStory: '#ff4b2e',
  twitter: '#1da1f2',
  youtube: '#ff0000'
};

export const warmGrays = [
  '#ebe8e8',
  '#d6d1d1',
  '#c2bab9',
  '#ada3a2',
  '#998c8b',
  '#847574',
  '#705e5d',
  '#5b4746',
  '#47302e',
  '#321917',
  '#1e0200'
];
